import * as Sentry from "@sentry/gatsby"

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.GATSBY_SENTRY_DSN,
    release: process.env.GATSBY_SENTRY_RELEASE,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    beforeSend(event, hint) {
      const message = event.message || ""
      const url = event.request?.url || ""
      const culprit = event.culprit || ""

      const exceptionValues = event.exception?.values?.map(v => v.value || "").join(" ") || ""
      const messageStack = `${message} ${exceptionValues}`

      const stackFilenames =
        event.exception?.values?.flatMap(v => v.stacktrace?.frames?.map(f => f.filename || "") || []) || []

      const ignoredSources = [
        "chrome-extension://",
        "moz-extension://",
        "safari-web-extension://",
        "ct.pinterest.com",
        "facebook.net",
        "google-analytics.com",
        "cdn.shopify.com",
      ]

      const ignoredMessages = [
        "NetworkError when attempting to fetch resource",
        "ResizeObserver loop limit exceeded",
        "Non-Error exception captured",
        "Script error.",
        "Non-Error promise rejection captured with value: Object Not Found Matching Id",
        "window.webkit.messageHandlers",
        "Load failed (t.thebettyrocker.com)",
      ]

      const isGbViewError =
        messageStack.includes("gbView") ||
        event.exception?.values?.some(exception =>
          exception.stacktrace?.frames?.some(frame => frame.function?.includes("gbView")),
        )

      const shouldIgnoreSource = ignoredSources.some(
        src =>
          url.includes(src) ||
          culprit.includes(src) ||
          messageStack.includes(src) ||
          stackFilenames.some(filename => filename.includes(src)),
      )

      if (shouldIgnoreSource || ignoredMessages.some(msg => messageStack.includes(msg)) || isGbViewError) {
        return null
      }

      return event
    },
  })

  if (typeof window !== "undefined") {
    window.Sentry = Sentry
  }
}
